module.exports = __webpack_public_path__ + "static/img/cs2.ca7d60a1.png";